var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useAppendedElement } from '../hooks/useAppendElement';
import { createPortal } from 'react-dom';
import { forwardRef } from 'react';
export var Overlay = forwardRef(function (props, ref) {
    var element = useAppendedElement();
    return createPortal(jsx("div", __assign({}, props, { sx: { position: 'absolute', zIndex: 'popover' }, ref: ref })), element);
});
//# sourceMappingURL=Overlay.js.map